var _style, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 48",
    style: {
      enableBackground: "new 0 0 297 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F9A947;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.5,28.8c-1.5,0-2.8-0.2-4-0.7c-1.2-0.5-2.2-1.2-3-2.1l3.4-4c0.5,0.6,1,1.1,1.5,1.4c0.5,0.3,1,0.5,1.5,0.5 c1.4,0,2.1-0.8,2.1-2.3v-7.2h-6.4V9.5h12.7v11.6c0,2.6-0.7,4.5-2,5.8C65,28.2,63.1,28.8,60.5,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.8,28.4L77,9.5h6.3l8.3,18.9H85l-6.1-15.9h2.5l-6.1,15.9H68.8z M73.7,25.1l1.6-4.6H84l1.6,4.6H73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.6,28.4V9.5h9.3c2.1,0,4,0.4,5.6,1.1c1.6,0.8,2.9,1.8,3.8,3.3c0.9,1.4,1.4,3.1,1.4,5c0,2-0.5,3.6-1.4,5.1 c-0.9,1.4-2.2,2.5-3.8,3.3c-1.6,0.8-3.5,1.1-5.6,1.1H92.6z M99,23.4h2.7c0.9,0,1.7-0.2,2.4-0.5s1.2-0.9,1.6-1.5s0.6-1.5,0.6-2.5 c0-1-0.2-1.8-0.6-2.4c-0.4-0.7-0.9-1.2-1.6-1.5s-1.5-0.5-2.4-0.5H99V23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.1,23.6h9.4v4.8h-15.7V9.5h15.4v4.8h-9.1V23.6z M120.7,16.5h8.4v4.6h-8.4V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.3,23.6h9.4v4.8H133V9.5h15.4v4.8h-9.1V23.6z M138.9,16.5h8.4v4.6h-8.4V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.2,28.4V9.5h9.3c2.1,0,4,0.4,5.6,1.1c1.6,0.8,2.9,1.8,3.8,3.3c0.9,1.4,1.3,3.1,1.3,5c0,2-0.5,3.6-1.3,5.1 c-0.9,1.4-2.2,2.5-3.8,3.3c-1.6,0.8-3.5,1.1-5.6,1.1H151.2z M157.6,23.4h2.7c0.9,0,1.7-0.2,2.4-0.5s1.2-0.9,1.6-1.5 s0.6-1.5,0.6-2.5c0-1-0.2-1.8-0.6-2.4c-0.4-0.7-0.9-1.2-1.6-1.5s-1.5-0.5-2.4-0.5h-2.7V23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.6,28.4V9.5h5.2l7.6,12.3h-2.8L199,9.5h5.2l0.1,18.9h-5.8l-0.1-10.1h0.9l-5,8.4h-2.8l-5.2-8.4h1.1v10.1 H181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.4,28.8c-2.9,0-5.2-0.8-6.8-2.3c-1.6-1.6-2.4-3.8-2.4-6.6V9.5h6.4v10.2c0,1.4,0.3,2.5,0.8,3.1 c0.5,0.6,1.2,0.9,2.1,0.9c0.9,0,1.6-0.3,2.1-0.9s0.8-1.6,0.8-3.1V9.5h6.3v10.4c0,2.8-0.8,5-2.4,6.6 C221.6,28,219.3,28.8,216.4,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.5,28.4V9.5h5.2l9.6,11.5h-2.4V9.5h6.2v18.9h-5.2l-9.6-11.5h2.4v11.5H228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.3,28.8c-1.6,0-3.1-0.2-4.6-0.5c-1.5-0.4-2.7-0.8-3.6-1.4l2.1-4.6c0.9,0.5,1.9,0.9,3,1.3 c1.1,0.3,2.2,0.5,3.2,0.5c0.6,0,1.1,0,1.4-0.1s0.6-0.2,0.8-0.4c0.2-0.2,0.2-0.3,0.2-0.6c0-0.3-0.2-0.6-0.6-0.8 c-0.4-0.2-0.9-0.4-1.5-0.5s-1.3-0.3-2-0.4c-0.7-0.2-1.5-0.4-2.2-0.6c-0.7-0.3-1.4-0.6-2.1-1c-0.6-0.4-1.1-1-1.5-1.6 s-0.6-1.5-0.6-2.5c0-1.2,0.3-2.2,1-3.2c0.7-1,1.6-1.7,2.9-2.3c1.3-0.6,2.9-0.9,4.9-0.9c1.3,0,2.5,0.1,3.8,0.4 c1.2,0.3,2.4,0.7,3.3,1.2l-1.9,4.6c-0.9-0.5-1.8-0.8-2.7-1.1s-1.7-0.4-2.6-0.4c-0.6,0-1.1,0.1-1.5,0.2c-0.4,0.1-0.6,0.3-0.8,0.4 c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.3,0.2,0.6,0.6,0.8s0.9,0.3,1.5,0.5c0.6,0.1,1.3,0.3,2.1,0.4c0.7,0.1,1.5,0.3,2.2,0.6 c0.7,0.3,1.4,0.6,2,1c0.6,0.4,1.1,1,1.5,1.6c0.4,0.7,0.6,1.5,0.6,2.5c0,1.2-0.3,2.2-1,3.2c-0.7,1-1.6,1.7-2.9,2.3 S259.2,28.8,257.3,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.3,28.4H268V9.5h6.4V28.4z M280.6,21.4h-6.7v-5.2h6.7V21.4z M280.2,9.5h6.4v18.9h-6.4V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.7,28.4V9.5h6.4v18.9H289.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,35.2l-1.3,1.2c-0.9-0.9-1.9-1.4-3-1.4c-0.9,0-1.7,0.3-2.4,0.9c-0.6,0.6-1,1.4-1,2.3 c0,0.6,0.1,1.2,0.4,1.7c0.3,0.5,0.7,0.9,1.2,1.2c0.5,0.3,1.1,0.4,1.7,0.4c0.5,0,1-0.1,1.5-0.3c0.4-0.2,0.9-0.6,1.5-1.1l1.3,1.3 c-0.7,0.7-1.4,1.2-2,1.4s-1.4,0.4-2.2,0.4c-1.5,0-2.8-0.5-3.7-1.4c-1-0.9-1.4-2.2-1.4-3.6c0-1,0.2-1.8,0.7-2.5 c0.4-0.7,1.1-1.3,1.9-1.8c0.8-0.5,1.7-0.7,2.6-0.7c0.8,0,1.6,0.2,2.3,0.5S62.9,34.6,63.4,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.9,33.3c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.5c-1,1-2.2,1.4-3.6,1.4 c-1.5,0-2.7-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.5c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.9-1.8C69.2,33.5,70,33.3,70.9,33.3z  M70.9,35c-0.9,0-1.7,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-0.9,2.3c0,1.1,0.4,1.9,1.2,2.5c0.6,0.5,1.3,0.7,2.1,0.7c0.9,0,1.6-0.3,2.2-0.9 c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3C72.6,35.4,71.8,35,70.9,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,33.5h1.8l2.3,6.7l2.3-6.7h1.8l1.6,9.6h-1.8l-1-6l-2.1,6h-1.6l-2.1-6l-1.1,6h-1.8L79.9,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.4,33.5h2c1.1,0,1.8,0.1,2.3,0.3c0.5,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.4,0.9,0.4,1.5c0,0.7-0.2,1.2-0.5,1.7 c-0.4,0.4-0.8,0.8-1.4,0.9c-0.4,0.1-1,0.1-2,0.1v4h-1.9V33.5z M94.3,37.2h0.6c0.5,0,0.8,0,1-0.1c0.2-0.1,0.3-0.2,0.4-0.3 c0.1-0.2,0.2-0.3,0.2-0.5c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.1-0.6-0.2-1.2-0.2h-0.5V37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.3,33.5h1.9v7.8h2.7v1.7h-4.6V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.5,33.5h5.3v1.8h-3.5V37h3.5v1.7h-3.5v2.5h3.5v1.8h-5.3V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,33.5h5.4v1.8h-1.8v7.8h-1.9v-7.8h-1.7V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.8,33.5h5.3v1.8h-3.5V37h3.5v1.7h-3.5v2.5h3.5v1.8h-5.3V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.2,33.5h4.8v1.8h-3V37h3v1.7h-3v4.3h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.8,33.5h1.8v9.6h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.9,33.5h1.8l4.2,6.3v-6.3h1.9v9.6H156l-4.2-6.3v6.3h-1.9V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.2,33.5h1.9l3.8,9.6h-1.9l-0.8-2h-4l-0.8,2h-1.9L164.2,33.5z M165.2,36l-1.3,3.3h2.6L165.2,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.5,33.5h1.8l4.2,6.3v-6.3h1.9v9.6h-1.8l-4.2-6.3v6.3h-1.9V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.8,35.2l-1.3,1.2c-0.9-0.9-1.9-1.4-3-1.4c-0.9,0-1.7,0.3-2.4,0.9c-0.6,0.6-1,1.4-1,2.3 c0,0.6,0.1,1.2,0.4,1.7c0.3,0.5,0.7,0.9,1.2,1.2c0.5,0.3,1.1,0.4,1.7,0.4c0.5,0,1-0.1,1.5-0.3c0.4-0.2,0.9-0.6,1.5-1.1l1.3,1.3 c-0.7,0.7-1.4,1.2-2,1.4s-1.4,0.4-2.2,0.4c-1.5,0-2.8-0.5-3.7-1.4s-1.4-2.2-1.4-3.6c0-1,0.2-1.8,0.7-2.5c0.4-0.7,1.1-1.3,1.9-1.8 c0.8-0.5,1.7-0.7,2.6-0.7c0.8,0,1.6,0.2,2.3,0.5C191.6,34.1,192.2,34.6,192.8,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.5,33.5h1.8v9.6h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.7,33.5h1.9l3.8,9.6h-1.9l-0.8-2h-4l-0.8,2h-1.9L203.7,33.5z M204.6,36l-1.3,3.3h2.6L204.6,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212,33.5h1.9v7.8h2.7v1.7H212V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.4,34.8L228,36c-0.5-0.7-1-1-1.5-1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.2,0.3-0.2,0.4 c0,0.2,0.1,0.3,0.2,0.5c0.2,0.2,0.6,0.6,1.4,1.2c0.7,0.6,1.1,0.9,1.3,1.1c0.4,0.4,0.6,0.7,0.8,1.1s0.2,0.7,0.2,1.1 c0,0.8-0.3,1.4-0.8,1.9c-0.6,0.5-1.3,0.8-2.2,0.8c-0.7,0-1.3-0.2-1.8-0.5c-0.5-0.3-1-0.9-1.3-1.6l1.6-0.9c0.5,0.8,1,1.3,1.6,1.3 c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.5-0.5-1.1-1c-1.1-0.8-1.7-1.5-2.1-2 c-0.3-0.5-0.5-0.9-0.5-1.4c0-0.7,0.3-1.2,0.8-1.7c0.5-0.5,1.2-0.7,1.9-0.7c0.5,0,1,0.1,1.4,0.3C228.4,33.8,228.9,34.2,229.4,34.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.2,33.3c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.5c-1,1-2.2,1.4-3.6,1.4 c-1.5,0-2.7-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.5c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.9-1.8C235.4,33.5,236.3,33.3,237.2,33.3z  M237.2,35c-0.9,0-1.7,0.3-2.3,0.9s-0.9,1.4-0.9,2.3c0,1.1,0.4,1.9,1.2,2.5c0.6,0.5,1.3,0.7,2.1,0.7c0.9,0,1.6-0.3,2.2-0.9 c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3C238.8,35.4,238.1,35,237.2,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.2,33.5h1.9v7.8h2.7v1.7h-4.6V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.4,33.5h1.9v6.2c0,0.5,0,0.9,0.1,1.1s0.3,0.4,0.5,0.5s0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2 s0.4-0.3,0.5-0.6c0.1-0.2,0.1-0.7,0.1-1.3v-6h1.9v5.7c0,1-0.1,1.6-0.2,2c-0.1,0.4-0.3,0.7-0.6,1.1c-0.3,0.3-0.7,0.6-1.1,0.8 c-0.4,0.2-0.9,0.2-1.4,0.2c-0.7,0-1.3-0.2-1.8-0.5c-0.5-0.3-0.9-0.7-1.1-1.2s-0.3-1.3-0.3-2.4V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.4,33.5h5.4v1.8H265v7.8h-1.9v-7.8h-1.7V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.2,33.5h1.8v9.6h-1.8V33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279,33.3c1.4,0,2.6,0.5,3.6,1.5c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.5c-1,1-2.2,1.4-3.6,1.4 c-1.5,0-2.7-0.5-3.6-1.5c-1-1-1.5-2.2-1.5-3.5c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.9-1.8C277.2,33.5,278.1,33.3,279,33.3z  M279,35c-0.9,0-1.7,0.3-2.3,0.9s-0.9,1.4-0.9,2.3c0,1.1,0.4,1.9,1.2,2.5c0.6,0.5,1.3,0.7,2.1,0.7c0.9,0,1.6-0.3,2.2-0.9 c0.6-0.6,0.9-1.4,0.9-2.3c0-0.9-0.3-1.7-0.9-2.3C280.6,35.4,279.9,35,279,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,33.5h1.8l4.2,6.3v-6.3h1.9v9.6h-1.8l-4.2-6.3v6.3H287V33.5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.5,0.1H4.3C1.9,0.1,0,2,0,4.4v39.1c0,2.4,1.9,4.3,4.3,4.3h39.1c2.4,0,4.3-1.9,4.3-4.3V4.4 C47.8,2,45.8,0.1,43.5,0.1z M20,26.7c0,2.4-0.6,4.3-1.8,5.5c-1.2,1.2-3,1.8-5.3,1.8c-1.3,0-2.6-0.2-3.7-0.7c-1.1-0.5-2-1.2-2.7-2.2 L9,28c0.5,0.7,1.1,1.3,1.7,1.6c0.6,0.4,1.3,0.5,2,0.5c1.9,0,2.8-1.1,2.8-3.2v-9.4H8.6v-3.7H20V26.7z M29,34l-7.3-20.1h4.6L33.7,34 H29z M36.6,34l-7.3-20.1H34L41.3,34H36.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a64eeae10cff4d4da812bb39e00c2415.svg";
export { ForwardRef as ReactComponent };